import React from 'react'
import ReactSelect from 'react-select'
import './Style.scss'

const selectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 38,
    borderRadius: 8,
    borderColor: state.isFocused ? '#2563eb' : '#ccc',
    boxShadow: state.isFocused ? '0 0 0 1px #2563eb' : 'none',
    backgroundColor: state.isDisabled ? '#f3f4f6' : '#fff',
    '&:hover': {
      borderColor: state.isFocused ? '#2563eb' : '#bbb'
    }
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '2px 8px'
  }),
  placeholder: (base) => ({
    ...base,
    color: '#9ca3af'
  }),
  menu: (base) => ({
    ...base,
    borderRadius: 8,
    overflow: 'hidden',
    zIndex: 20
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? '#dbeafe'
      : state.isFocused
      ? '#f3f4f6'
      : '#fff',
    color: '#111827'
  }),
  singleValue: (base) => ({
    ...base,
    margin: 0,
    maxWidth: '100%'
  })
}

const BaseSelectInput = ({
  name,
  value,
  onChange,
  options = [],
  placeholder = 'Select...',
  disabled = false,
  isClearable = false,
  isSearchable = true,
  blurInputOnSelect = true,
  getOptionValue,
  getOptionLabel,
  components,
  className = '',
  ...rest
}) => {
  return (
    <ReactSelect
      name={name}
      value={value}
      onChange={onChange}
      options={options}
      placeholder={placeholder}
      isDisabled={disabled}
      isClearable={isClearable}
      isSearchable={isSearchable}
      blurInputOnSelect={blurInputOnSelect}
      getOptionValue={getOptionValue}
      getOptionLabel={getOptionLabel}
      components={components}
      className={className}
      styles={selectStyles}
      menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
      menuPosition='fixed'
      {...rest}
    />
  )
}

export default BaseSelectInput
